import { BaseResourceModel } from '../../models/base-resource.model';
import { EmpenhoExtra } from './empenho-extra.model';

// tslint:disable: variable-name

export class EmpenhoExtraIsencaoReinf extends BaseResourceModel {
    constructor(
        public id?: number,
        public tipo?: number,
        public valor_isento?: number,
        public descricao?: string,
        public data_laudo?: string,
        public empenho_extra?: EmpenhoExtra,
    ) {
        super();
    }

    static converteJson(json: any): EmpenhoExtraIsencaoReinf {
        return Object.assign(new EmpenhoExtraIsencaoReinf(), json);
    }
}
